var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import Pin from '@spa/shared/svg/pin';
import { theme } from '@spa/offer/theme';
import Share from '@spa/shared/svg/share';
import ReportFlag from '@spa/shared/svg/report-flag';
import HeartOutline from '@spa/shared/svg/heart-outline';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { translateFromLanguage } from '@spa/shared/utils/transformers';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { generateOfferTags, generateTitleData } from '@spa/offer/utils/headerTitle';
import { Wrapper, Title, Tags, Location, BottomLine, Actions, Action } from './styles';
import { addToWishlistAction, removeFromWishlistAction } from '@spa/shared/store/actions/profile';
import { trackAddToWishlist, trackReportListingOpen, trackShareLink } from '@spa/offer/store/actions/tracking';
var HeaderTitleDesktop = function HeaderTitleDesktop(_ref) {
  var _neighborhood$metadat;
  var offerId = _ref.offerId,
    accommodationOffer = _ref.accommodationOffer,
    neighborhood = _ref.neighborhood,
    city = _ref.city,
    titleTranslations = _ref.titleTranslations,
    cityTranslations = _ref.cityTranslations,
    rentBy = _ref.rentBy,
    bedType = _ref.bedType,
    bathroomType = _ref.bathroomType,
    numberOfBedrooms = _ref.numberOfBedrooms,
    numberOfBathrooms = _ref.numberOfBathrooms,
    hasElevator = _ref.hasElevator,
    propertyType = _ref.propertyType,
    maxGuests = _ref.maxGuests,
    area = _ref.area,
    street = _ref.street,
    isLoggedIn = _ref.isLoggedIn,
    isWishlistLoading = _ref.isWishlistLoading,
    isOnWishlist = _ref.isOnWishlist,
    showWishlistModal = _ref.showWishlistModal,
    showShareModal = _ref.showShareModal,
    showReportModal = _ref.showReportModal,
    addToWishlist = _ref.addToWishlist,
    removeFromWishlist = _ref.removeFromWishlist,
    trackReportListingOpenAction = _ref.trackReportListingOpenAction,
    trackAddToWishlistAction = _ref.trackAddToWishlistAction,
    trackShareLinkAction = _ref.trackShareLinkAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var tags = generateOfferTags({
    rentBy: rentBy,
    bedType: bedType,
    bathroomType: bathroomType,
    numberOfBedrooms: numberOfBedrooms,
    numberOfBathrooms: numberOfBathrooms,
    hasElevator: hasElevator,
    propertyType: propertyType,
    maxGuests: maxGuests,
    area: area,
    t: t
  });
  var handleWishlistClick = function handleWishlistClick() {
    trackAddToWishlistAction(accommodationOffer, city, neighborhood, language);
    if (!isLoggedIn) {
      showWishlistModal();
      return;
    }
    isOnWishlist ? removeFromWishlist({
      offerId: offerId,
      city: city
    }) : addToWishlist({
      offerId: offerId,
      city: city
    });
  };
  var showReportListingModal = function showReportListingModal() {
    showReportModal();
    trackReportListingOpenAction();
  };
  var showShareListingModal = function showShareListingModal() {
    showShareModal();
    trackShareLinkAction();
  };
  return __jsx(Wrapper, null, __jsx(Title, null, translateFromLanguage(titleTranslations, language)), __jsx(Tags, null, tags.map(function (tag, i) {
    return __jsx("span", {
      key: tag
    }, tag, i !== tags.length - 1 && __jsx("span", null, "\u2022"));
  })), __jsx(BottomLine, null, __jsx(Location, null, __jsx(Pin, null), [street, translateFromLanguage(neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$metadat = neighborhood.metadata) === null || _neighborhood$metadat === void 0 ? void 0 : _neighborhood$metadat.name_translations, language), translateFromLanguage(cityTranslations, language)].filter(function (item) {
    return item && item.trim();
  }).join(', ')), __jsx(Actions, null, __jsx(Action, {
    role: 'button',
    onClick: handleWishlistClick,
    isLoading: isWishlistLoading
  }, __jsx(HeartOutline, {
    color: theme.headerTitle.actions.color,
    strokeWidth: 1,
    filled: isOnWishlist
  }), ' ', t(isOnWishlist ? 'Saved' : 'Save')), __jsx(Action, {
    role: 'button',
    onClick: showShareListingModal
  }, __jsx(Share, {
    color: theme.headerTitle.actions.color
  }), " ", t('Share')), __jsx(Action, {
    role: 'button',
    onClick: showReportListingModal
  }, __jsx(ReportFlag, {
    color: theme.headerTitle.actions.color,
    width: 24,
    height: 24
  }), " ", t('Report')))));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _wishlist$cities;
  var offerAggregate = _ref2.offer.offerAggregate,
    _ref2$profile = _ref2.profile,
    isLoggedIn = _ref2$profile.isLoggedIn,
    wishlist = _ref2$profile.wish_list;
  var accommodationOffer = offerAggregate.accommodation_offer,
    _offerAggregate$globa = offerAggregate.globalization_aggregate.city,
    cityTranslations = _offerAggregate$globa.metadata.name_translations,
    city = _offerAggregate$globa.configuration.slug,
    _offerAggregate$prope = offerAggregate.property_aggregate,
    neighborhood = _offerAggregate$prope.neighborhood,
    street = _offerAggregate$prope.property.location.address.street;
  var offerId = accommodationOffer.id,
    titleTranslations = accommodationOffer.title;
  var _generateTitleData = generateTitleData(offerAggregate),
    rentBy = _generateTitleData.rentBy,
    bedType = _generateTitleData.bedType,
    bathroomType = _generateTitleData.bathroomType,
    numberOfBedrooms = _generateTitleData.numberOfBedrooms,
    numberOfBathrooms = _generateTitleData.numberOfBathrooms,
    hasElevator = _generateTitleData.hasElevator,
    propertyType = _generateTitleData.propertyType,
    maxGuests = _generateTitleData.maxGuests,
    area = _generateTitleData.area;
  var isOnWishlist = wishlist === null || wishlist === void 0 ? void 0 : (_wishlist$cities = wishlist.cities) === null || _wishlist$cities === void 0 ? void 0 : _wishlist$cities.items.some(function (_ref3) {
    var accommodation_offer_ids = _ref3.accommodation_offer_ids;
    return accommodation_offer_ids.includes(offerId);
  });
  return {
    offerId: offerId,
    accommodationOffer: accommodationOffer,
    neighborhood: neighborhood,
    city: city,
    titleTranslations: titleTranslations,
    cityTranslations: cityTranslations,
    rentBy: rentBy,
    bedType: bedType,
    bathroomType: bathroomType,
    numberOfBedrooms: numberOfBedrooms,
    numberOfBathrooms: numberOfBathrooms,
    hasElevator: hasElevator,
    propertyType: propertyType,
    maxGuests: maxGuests,
    area: area,
    isLoggedIn: isLoggedIn,
    isOnWishlist: isOnWishlist,
    isWishlistLoading: wishlist === null || wishlist === void 0 ? void 0 : wishlist.isLoading,
    street: street
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showWishlistModal: function showWishlistModal() {
      return dispatch(showModalAction({
        modalId: modalIds.WISHLIST
      }));
    },
    showShareModal: function showShareModal() {
      return dispatch(showModalAction({
        modalId: modalIds.SHARE
      }));
    },
    showReportModal: function showReportModal() {
      return dispatch(showModalAction({
        modalId: modalIds.REPORT_LISTING
      }));
    },
    addToWishlist: function addToWishlist(_ref4) {
      var offerId = _ref4.offerId,
        city = _ref4.city;
      return dispatch(addToWishlistAction({
        offerId: offerId,
        city: city
      }));
    },
    removeFromWishlist: function removeFromWishlist(_ref5) {
      var offerId = _ref5.offerId,
        city = _ref5.city;
      return dispatch(removeFromWishlistAction({
        offerId: offerId,
        city: city
      }));
    },
    trackReportListingOpenAction: function trackReportListingOpenAction() {
      return dispatch(trackReportListingOpen());
    },
    trackAddToWishlistAction: function trackAddToWishlistAction(offer, citySlug, neighborhood, language) {
      return dispatch(trackAddToWishlist({
        offer: offer,
        citySlug: citySlug,
        neighborhood: neighborhood,
        language: language
      }));
    },
    trackShareLinkAction: function trackShareLinkAction() {
      return dispatch(trackShareLink());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HeaderTitleDesktop);